module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mushroom !== null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 text-left"
  }, [_vm._v("\n      ชื่อเห็ดไทย: " + _vm._s(_vm.mushroom.mushroom_thai) + " "), _c('br'), _vm._v("\n      ชื่อวิทยาศาสตร์: " + _vm._s(_vm.mushroom.mushroom_science) + " "), _c('br'), _vm._v("\n      ประเภทเห็ด: " + _vm._s(_vm.getMushroomTypeText(_vm.mushroom.mushroom_type)) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 text-left"
  }, [_vm._v("\n      ผลการตรวจวิเคราะห์: " + _vm._s(_vm.mushroom.analysis_result) + " "), _c('br'), _vm._v("\n      สรุปผลการตรวจวิเคราะห์: " + _vm._s(_vm.mushroom.summary_result) + " "), _c('br'), _vm._v("\n      ผู้ตรวจวิเคราะห์: " + _vm._s(_vm.mushroom.analyst) + " "), _c('br'), _vm._v("\n      หมายเหตุ: " + _vm._s(_vm.mushroom.note) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 text-left"
  }, [_vm._v("\n      ข้อมูลพื้นที่พบเห็ด "), _c('br'), _vm._v("\n      ต." + _vm._s(_vm.mushroom.ttname) + " อ." + _vm._s(_vm.mushroom.amname) + " จ." + _vm._s(_vm.mushroom.prv_name_th) + " "), _c('br'), _vm._v("\n      ละติจูด: " + _vm._s(_vm.mushroom.latitude) + "  "), _c('br'), _vm._v("\n      ลองจิจูด: " + _vm._s(_vm.mushroom.longitude) + "\n    ")])]) : _c('div', {
    staticClass: "row text-center"
  }, [_vm._v("\n    ไม่พบข้อมูลผลวิเคราะห์\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveAlert($event)
      }
    }
  }, [(_vm.mushroom !== null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("แจ้งเตือนไปยังพื้นที่ :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_vm._v("จ." + _vm._s(_vm.mushroom.prv_name_th))])]) : _vm._e(), _vm._v(" "), (_vm.mushroom !== null) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("ข้อความแจ้งเตือน :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v("ภาพประกอบ :")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 text-left",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "image",
      "name": "image",
      "accept": "image/*"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 text-right",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          ส่งการแจ้งเตือน\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3792d215","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertToUser.vue
// module id = 1085
// module chunks = 1